export default {
  no_results: {
    title: 'Brak wyników dla „{{search}}"',
    desc: 'Przepraszamy, nic nie znaleźliśmy. Spróbuj innego hasła.',
  },
  empty_menu: {
    title: 'Brak dostępnych pozycji',
    desc: 'To menu nie ma teraz nic do pokazania. Wróć wkrótce.',
  },
};
